export default __webpack_public_path__ + "static/OptionalChallenges-305d5fd8736b746f806f71ad3c01fb12.webp";